module.exports = __webpack_public_path__ + "static/media/event8.01122d97.jpeg";